import { render, staticRenderFns } from "./MonthData.vue?vue&type=template&id=20fac645&scoped=true&"
import script from "./MonthData.vue?vue&type=script&lang=js&"
export * from "./MonthData.vue?vue&type=script&lang=js&"
import style0 from "./MonthData.vue?vue&type=style&index=0&id=20fac645&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fac645",
  null
  
)

export default component.exports